export default __webpack_public_path__ + "static/media/f.828735ab.png";